module.exports = __webpack_public_path__ + "static/media/moving-chairs-pandora-jane-knocker.8f593f3d.png";